// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__03tDj","products":"SearchPopUp_products__yqxse"};